<span class="badge badge-primary mr-1" [ngClass]="statusClassMap">{{
  statusValue
}}</span>
